/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllCarveOutTrackingResponse } from './FindAllCarveOutTrackingResponse';
import {
    FindAllCarveOutTrackingResponseFromJSON,
    FindAllCarveOutTrackingResponseFromJSONTyped,
    FindAllCarveOutTrackingResponseToJSON,
    FindAllCarveOutTrackingResponseToJSONTyped,
} from './FindAllCarveOutTrackingResponse';

/**
 * 
 * @export
 * @interface FindAllCarveOutTracking200Response
 */
export interface FindAllCarveOutTracking200Response {
    /**
     * 
     */
    data?: FindAllCarveOutTrackingResponse;
}

/**
 * Check if a given object implements the FindAllCarveOutTracking200Response interface.
 */
export function instanceOfFindAllCarveOutTracking200Response(value: object): value is FindAllCarveOutTracking200Response {
    return true;
}

export function FindAllCarveOutTracking200ResponseFromJSON(json: any): FindAllCarveOutTracking200Response {
    return FindAllCarveOutTracking200ResponseFromJSONTyped(json, false);
}

export function FindAllCarveOutTracking200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCarveOutTracking200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllCarveOutTrackingResponseFromJSON(json['data']),
    };
}

export function FindAllCarveOutTracking200ResponseToJSON(json: any): FindAllCarveOutTracking200Response {
    return FindAllCarveOutTracking200ResponseToJSONTyped(json, false);
}

export function FindAllCarveOutTracking200ResponseToJSONTyped(value?: FindAllCarveOutTracking200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllCarveOutTrackingResponseToJSON(value['data']),
    };
}

